<template>
    <el-dialog title="自定义表单明细表单配置"
               :visible.sync="visible"
               :fullscreen="true"
    >
        <div class="edit-form">
            <el-tabs v-model="activeName" @tab-click="tableChange">
                <el-tab-pane label="数据集列表" name="basicInfo">
                    <config-dataset-list v-if="isRouterAlive" :formId.sync="formId" :show-history-tag="showHistoryTag" />
                </el-tab-pane>
                <el-tab-pane label="查询参数配置" name="searchArg">
                    <config-search-arg v-if="isRouterAlive" :formId.sync="formId" />
                </el-tab-pane>
                <el-tab-pane label="字段映射" name="datasetField">
                    <config-dataset-field v-if="isRouterAlive" :formId.sync="formId" :busType.sync="busType" />
                </el-tab-pane>
            </el-tabs>
        </div>
    </el-dialog>
</template>

<script>
import ConfigDatasetField from "./DetailConfigDatasetField";
import ConfigDatasetList from "./DetailConfigDatasetList";
import ConfigSearchArg from "./DetailConfigSearchArg";

export default {
    name: 'detail-config-dialog',
    components: {
        ConfigDatasetField,
        ConfigSearchArg,
        ConfigDatasetList
    },
    props: {
        formId: {
            type: String,
            default: '',
        },
        busType: {
            type: String,
            default: '',
        },
        showHistoryTag: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            visible: false,
            activeName: "basicInfo",
            isRouterAlive: true,
        }
    },
    methods: {
        openVisible() {
            this.visible = true;
            this.reload();
        },
        getDatasourceTitle(){
            if(this.dataForm.attributes!=undefined && this.dataForm.attributes.datasourceId!=undefined){
                return this.dataForm.attributes.datasourceId;
            }
            return '无'
        },
        loadData() {
            this.activeName = "basicInfo";
        },
        tableChange(tab, event) {
            this.activeName = tab.name;
        },
        reload() {
            this.isRouterAlive = false
            this.$nextTick(() => {
                this.isRouterAlive = true;
                this.loadData();
            })
        },
    }
}
</script>

<style lang="less" scoped>
.edit-form {
    height: 100%;
    overflow: scroll;
}
</style>
